import React from 'react';
import { useGate } from 'statsig-react';
import { FEATURE_GATES, NAV_LINKS } from '@utils/constants';
import { ChartCard } from './ChartCard';

export const ChartsSection = () => {
  const { value: pointsEnabled } = useGate(FEATURE_GATES.SOCIALS_POINTS);
  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex justify-between">
        <h3 className="font-title text-title-m font-medium md:text-title-l">Charts</h3>
      </div>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-4 md:gap-4 lg:grid-cols-5 xl:grid-cols-6">
        <ChartCard
          key="viralSounds"
          label="Viral Sounds"
          pathnameUri={pointsEnabled ? NAV_LINKS.ViralSounds : NAV_LINKS.ViralChartsSounds}
          className="bg-education200"
        />
        <ChartCard
          key="viralPlaylists"
          label="Viral Playlists"
          pathnameUri={pointsEnabled ? NAV_LINKS.ViralPlaylists : NAV_LINKS.ViralChartsPlaylists}
          className="bg-brand500"
        />
        <ChartCard
          key="topSongs"
          label="Top Songs"
          pathnameUri={NAV_LINKS.TopSongs}
          className="bg-orange100"
        />
        <ChartCard
          key="topArtists"
          label="Top Artists"
          pathnameUri={NAV_LINKS.TopArtists}
          className="bg-fuchsia500"
        />
        <ChartCard
          key="topCollectors"
          label="Top Collectors"
          pathnameUri={NAV_LINKS.TopCollectors}
          className="bg-base600"
        />
        <ChartCard
          key="topCurators"
          label="Top Curators"
          pathnameUri={NAV_LINKS.TopCurators}
          className="bg-destructive100"
        />
      </div>
    </div>
  );
};
